import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Modal from '../Modal'
import Footer from '../Footer/Footer'
import { logAudioClick, SECTIONS } from '../../utils/contentConsumption'
import './category.css'
function CategoryDetail() {
    const { id } = useParams()
    const [categorydata, setCategoryData] = useState([])
    const [category, setCategoryName] = useState('')
    const [loading, setLoading] = useState('')
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null
    useEffect(() => {
        console.log(id);
        getyDetails()
    }, [])
    const navigate = useNavigate();
    const openAudioFile = (audio_file_id) => {
        logAudioClick(audio_file_id, SECTIONS.CATEGORY_DETAIL);
        navigate(`/audio-file-detail/${audio_file_id}`);
    };
    const getyDetails = () => {
        setLoading(true)
        let data = JSON.stringify({
            "category_id": id
        });
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://api.dastaan.info/api/v1/category-audio-files',
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(config);
        // return
        axios.request(config).then((response) => {
            setLoading(false)
            // console.log(response.data);
            setCategoryData(response?.data?.data)
            setCategoryName(response?.data?.cat_name)
        })
    }
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const plan_active = localStorage.getItem('dastaan__plan_active');
    return (
        <>
            <Container className='category-detail-container'>
                <Row className=''>
                    <Col md={12} lg={12} xs={12} sm={12} >
                        <h5 className='search-heading mt-5'><b>{category}</b></h5>
                    </Col>
                    {
                        categorydata.map((audFile) => {
                            return (
                                <Col md={2} sm={4} xs={4} className='mt-3 p-1'>
                                    <div
                                        // onClick={() => user_id !== null ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : setShowModal(true)}
                                        onClick={() => (user_id !== null && plan_active === 'true') ? openAudioFile(audFile.audio_file_id) : (user_id !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                                        key={audFile.audio_file_id} className="card-wrapper">
                                        <div className="card">
                                            <div className='image'>
                                                <img src={audFile.landscape_thumb} alt={audFile.title} className="card-img-top slick-slider-img" />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
            <Modal show={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}
export default CategoryDetail